import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from "@angular/core";
import { NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import _, { uniqBy } from "lodash";
import { IContent } from "~app/common/models/validationModel";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { NgClass } from "@angular/common";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: "rask-error-modal",
    styleUrls: ["./error.component.scss"],
    templateUrl: "./error.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        NgClass,
        TranslatePipe
    ]
})
export class ErrorModalComponent implements OnInit {

    header: string;
    messages: IContent[];
    modalRef: NgbModalRef;
    highestSeverity = 2;
    copyFn: () => void;

    ngOnInit() {
        const validationMessages = this.messages?.filter(x => ObjectUtils.hasValue(x.validationMessages)) ?? [];
        const allSeverities = validationMessages?.map(x => this.getMaxSeverity(x));
        if (allSeverities.length > 0) {
            this.highestSeverity = _.max(allSeverities);
        }
    }

    protected getMessages(): IContent[] {
        const errorMessages = this.messages?.filter(m => ObjectUtils.isNullOrUndefined(m.validationMessages)) ?? [];
        const validationMessages = this.messages?.filter(m => ObjectUtils.hasValue(m.validationMessages)) ?? [];
        return validationMessages.concat(uniqBy(errorMessages, m => m.message));
    }

    protected done(): void {
        this.modalRef.close();
    }

    protected hasForce(): boolean {
        return this.messages?.some(x => x.canForce);
    }

    protected force(): void {
        this.modalRef.close("force");
    }

    protected hasCopy(): boolean {
        return ObjectUtils.hasValue(this.copyFn) &&
               this.messages?.length > 0 &&
               !(this.messages.some(m => m.validationMessages?.length > 0));
    }

    protected copy(): void {
        this.copyFn();
    }

    private getMaxSeverity(content: IContent): any {
        // eslint-disable-next-line sonarjs/reduce-initial-value
        return content.validationMessages.reduce((prev, curr) => (prev.severity > curr.severity) ? prev : curr);
    }
}
